<div style="margin: 10px;">
  <form [formGroup]="SettingsForm">
    <legend>Basic Settings</legend>
    <div style="height: 10px;"></div>
    <div class="mb-3 row" [ngClass]="{'has-error':!Name.valid}">
      <div class="col-lg-1">
        <label class="col-form-label">Name</label>
      </div>
      <div class="col-lg-6">
        <input type="text" class="form-control" [formControl]="Name" />
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="Enabled" />
        <span class="uv-checkbox-label">Enabled</span>
      </div>
    </div>
    @if (Name.hasError('required')) {
      <div class="alert alert-danger">Name is required</div>
    }
    <div class="mb-3 section" [ngClass]="{'has-error':!Method.valid}">
      <label>Discovery Method</label><br>
      <div>
        <input type="radio" name="discMethod" value="1" [formControl]="Method" /><span class="uv-checkbox-label" title="Use Seed IP range(s) to scan network for IP devices.&#013;This discovery will be restricted to the supplied Seed IP Addresses / IP Ranges.">Ping Sweep</span><br>
        <input type="radio" name="discMethod" value="2" [formControl]="Method" /><span class="uv-checkbox-label" title="ARP Cache discovery uses ARP tables as well as other IP sighting methods to discover your full network.&#013;It uses Seed IP Addresses / IP Ranges as a starting point for discovery and then uses ARP to crawl to all areas of your network.&#013;Recommended for discovering all devices on a network.">ARP Cache</span><br>
        <input type="radio" name="discMethod" value="3" [formControl]="Method" /><span class="uv-checkbox-label" title="Quick Scan incorporates device proprietary sightings (i.e. CDP/LLDP) to discovery your network.&#013;This method is best suited for discovering only network devics like routers/switches/access points.&#013;It uses the Seed IP Addresses / IP Ranges as a starting point and then uses the proprietary sightings (i.e. CDP) to expand its discovery.&#013;Recommended if you only want to discover your Cisco devices.">Quick Scan</span><br>
      </div>
      @if (Method.hasError('required')) {
        <div class="alert alert-danger">Discovery Method is required</div>
      }
    </div>
    <div class="mb-3 row section">
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="RefreshMode" />
        <span class="uv-checkbox-label">Refresh Mode</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="ReportSubtaskStatus" />
        <span class="uv-checkbox-label">Report Detailed Status</span>
      </div>
    </div>
    <div class="mb-3 row section">
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="KeepStalePortReport" />
        <span class="uv-checkbox-label">Keep Stale Port Report</span>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-3">
        <input type="checkbox" style="margin-left:10px" [formControl]="DisableStalePorts" />
        <span class="uv-checkbox-label">Disable stale switch ports after being down</span>
      </div>
      <div class="col-lg-1">
        <input type="number" class="form-control" [formControl]="DisableStalePortsTime" />
      </div>
      <div class="col-lg-2">
        <select class="form-control" [formControl]="DisableStalePortsUnit">
          <option value="0">days</option>
          <option value="1">hours</option>
        </select>
      </div>
    </div>
    <div class="mb-3 section" [ngClass]="{'has-error':!SeedScope.valid}">
      <label>Seed IP Addresses / IP Ranges</label>
      <div class="mb-3 row">
        <div class="col-lg-8">
          <textarea rows="10" cols="50" class="form-control" [formControl]="SeedScope"></textarea>
          @if (SeedScope.hasError('required')) {
            <div class="alert alert-danger">Seed IP Addresses/Ranges are required</div>
          }
        </div>
      </div>
    </div>
    <div class="mb-3 row section" [ngClass]="{'has-error':!Keep.valid}">
      <div class="col-lg-1">
        <span>Keep</span>
      </div>
      <div class="col-lg-1">
        <input type="number" class="form-control" [formControl]="Keep" />
      </div>
      <div class="col-lg-2">
        <span>discovery results</span>
      </div>
    </div>
    @if (Keep.hasError('required')) {
      <div class="alert alert-danger">This value is required</div>
    }
    @if (Keep.hasError('minValue') || Keep.hasError('maxValue')) {
      <div class="alert alert-danger">This value must be in the range 1 - 99</div>
    }
    <div class="mb-3 row">
      <div class="col-lg-3">
        <span>Remember dynamic devices for:</span>
      </div>
      <div class="col-lg-1" [ngClass]="{'has-error':!DeviceExpirationValue.valid}">
        <input type="number" class="form-control" [formControl]="DeviceExpirationValue" />
      </div>
      <div class="col-lg-2">
        <select class="form-control" [formControl]="DeviceExpirationUnit">
          <option value="0">days</option>
          <option value="1">hours</option>
          <option value="2">minutes</option>
        </select>
      </div>
    </div>
    @if (DeviceExpirationValue.hasError('required')) {
      <div class="alert alert-danger">This value is required</div>
    }
    @if (DeviceExpirationValue.hasError('minValue') || DeviceExpirationValue.hasError('maxValue')) {
      <div class="alert alert-danger">This value must be in the range 0 - 999</div>
    }
  </form>


</div>
